import { gql } from '@apollo/client';

export const GET_INVENTORY_PDF_LINK = gql`
  query GetInventoryPdfLink($inventory_id: String!) {
    getInventoryPdfLink(inventory_id: $inventory_id) {
      status
      message
      download_url
      mime_type
    }
  }
`;
